import { useTranslation } from 'react-i18next';
import { Button, Icon, Stack, TextField } from '../../../../../../base-components';
import { IActiveFilter } from '../../../../../table.interfaces';

interface INumberRangeMenuProps {
    activeFilterIndex: number;
    activeFilters: Array<IActiveFilter>;
    onChange: (values: [number | null, number | null]) => void;
    minValue?: number;
    maxValue?: number;
}

const NumberRangeMenu = ({
    activeFilterIndex,
    activeFilters,
    onChange,
    minValue,
    maxValue,
}: INumberRangeMenuProps) => {
    const { t } = useTranslation();
    const [min, max] = activeFilters[activeFilterIndex].values as [
        number | null,
        number | null,
    ];

    const parseInput = (value: string): number | null => {
        if (value === '') return null;
        let parsed = Number(value);
        if (minValue !== undefined) parsed = Math.max(parsed, minValue);
        if (maxValue !== undefined) parsed = Math.min(parsed, maxValue);
        return parsed;
    };

    return (
        <Stack
            padding={2}
            gap={1.5}
        >
            <TextField
                type="number"
                size="small"
                label={t('filters.min')}
                value={min ?? ''}
                inputProps={{ min: minValue, max: maxValue }}
                onChange={(event) =>
                    onChange([parseInput(event.target.value), max])
                }
            />
            <TextField
                type="number"
                size="small"
                label={t('filters.max')}
                value={max ?? ''}
                inputProps={{ min: minValue, max: maxValue }}
                onChange={(event) =>
                    onChange([min, parseInput(event.target.value)])
                }
            />
            <Button
                variant="outlined"
                color="secondary"
                onClick={() => onChange([null, null])}
                startIcon={<Icon name="DeleteIcon" />}
                fullWidth
            >
                {t('filters.clearAllRange')}
            </Button>
        </Stack>
    );
};

export default NumberRangeMenu;
